var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartToy(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.999-376q-45 0-76-31.208Q27-438.417 27-483t31.209-75.792Q89.416-590 133.999-590v-136.001q0-24 18-42t42-18H373q0-45 31.208-76 31.209-31 75.792-31t75.792 31.209Q587-830.584 587-786.001h179.001q24 0 42 18t18 42V-590q45 0 76 31.208 31 31.209 31 75.792t-31.209 75.792Q870.584-376 826.001-376v209.001q0 24-18 42t-42 18H193.999q-24 0-42-18t-18-42V-376Zm212.628-103.391q17.895 0 30.243-12.584 12.348-12.583 12.348-30.761 0-18.177-12.583-30.525-12.584-12.348-30.479-12.348t-30.526 12.536Q303-540.537 303-521.982q0 17.895 12.866 30.243 12.866 12.348 30.761 12.348Zm267.217 0q17.895 0 30.526-12.584Q657-504.558 657-522.736q0-18.177-12.866-30.525-12.866-12.348-30.761-12.348t-30.243 12.536q-12.348 12.536-12.348 31.091 0 17.895 12.583 30.243 12.584 12.348 30.479 12.348ZM318.218-285h323.564v-66.218H318.218V-285Zm-105 98.782h533.564v-520.564H213.218v520.564ZM480-447Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/smart_toy-cf3092a2.svg";
export { SvgSmartToy as ReactComponent };